/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { z } from "zod";
import { MetadataSchema } from "~/components";
import { safeStr, stringRequired } from "~/components/Forms";
import { FormField } from "../formConfig";

const maxPlanActionNameLength = 100;

export const ResourceGroupDetailsSchema = z.object({
  [FormField.NAME]: stringRequired("Name").max(
    100,
    `Name is too long (max: ${maxPlanActionNameLength} characters).`
  ),
  [FormField.DESCRIPTION]: safeStr.optional(),
  [FormField.METADATA]: MetadataSchema.optional(),
});
